export default __webpack_public_path__ + "static/media/most-popular-artwork-4.936865da.png";